import React from 'react';
import {FullScreen, ButtonContainer, ButtonListarea, ButtonList, CancelButtonarea, ButtonStyle, LinkStyle, CancelButton} from './style';

export default function BottomModal({visible, setVisible, dataList}) {
    if(!visible) return null;
    return (
        <FullScreen>
            <ButtonContainer>
                <ButtonListarea>
                    {dataList.map((list, index) => 
                        <ButtonList key={`modal-data-list-index-${index}`}>
                            {list.type === 'callback' ?
                            <ButtonStyle onClick={() => list.callback(list.callbackParam !== undefined ? list.callbackParam : undefined)} style={list.style ? list.style : null }>{list.text}</ButtonStyle>
                            : <LinkStyle to={list.path}>{list.text}</LinkStyle>}
                        </ButtonList>
                    )}
                </ButtonListarea>
                <CancelButtonarea>
                    <CancelButton onClick={() => setVisible(false)}>취소</CancelButton>
                </CancelButtonarea>
            </ButtonContainer>
        </FullScreen>
    )
}